import { getDayJs } from '~/services/TimeService';

import { flagLabels } from './logic';
import { actionFlag, marginBandLabels, medianBand } from './marginBands';
import { CommandDeparture, CommandFlag, CostBasis } from './types';

export const departureActionOrder: CommandFlag[] = [
  'red',
  'amber',
  'empty',
  'early',
  'unavailable',
  'closed',
  'ltle copy',
  'handed back',
  'green',
];

export const departureActionDefinitions: Array<{ flag: CommandFlag; label: string; description: string }> = [
  {
    flag: 'red',
    label: flagLabels.red,
    description: 'Predicted margin under 5%, Medium or High confidence, and handback within 240 days.',
  },
  {
    flag: 'amber',
    label: flagLabels.amber,
    description: 'Predicted margin 5 to 10%, or under 5% with Low or Indicative confidence.',
  },
  { flag: 'green', label: flagLabels.green, description: 'Predicted margin 10% or more.' },
  { flag: 'empty', label: flagLabels.empty, description: 'On sale, no bookings, handback within 120 days.' },
  { flag: 'early', label: flagLabels.early, description: 'On sale, no bookings, handback more than 120 days away.' },
  {
    flag: 'unavailable',
    label: flagLabels.unavailable,
    description:
      "Margin can't be worked out, for example no price, no recorded cost, or all bookings still waiting for their hotel order.",
  },
  { flag: 'closed', label: flagLabels.closed, description: 'Not on sale and no bookings.' },
  {
    flag: 'handed back',
    label: flagLabels['handed back'],
    description: 'Handback has passed. Numbers are final and there is no action.',
  },
];

export function departureActionGroups(rows: CommandDeparture[], basis: CostBasis) {
  const groups = departureActionOrder
    .map((flag) => ({ flag, rows: rows.filter((d) => actionFlag(d, basis) === flag) }))
    .filter((g) => g.rows.length);
  const actionable = groups.filter((g) => ['red', 'amber', 'empty'].includes(g.flag));
  return actionable.length ? actionable : groups;
}

export function departureActionReason(d: CommandDeparture, basis: CostBasis): string {
  const flag = actionFlag(d, basis);
  const band = medianBand(d, basis);
  return ['red', 'amber', 'green'].includes(flag) && band
    ? `${marginBandLabels[band]} median margin`
    : flagLabels[flag];
}

export function departureActionDetail(d: CommandDeparture, basis: CostBasis, includeTour = false): string {
  return `${includeTour ? `${d.opp_name} · ` : ''}${getDayJs(d.dep).format('D MMM YY')}: ${departureActionReason(d, basis)}`;
}
